import {Component, inject} from '@angular/core';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatOption, MatSelect} from '@angular/material/select';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {UserService} from '../../../services/user.service';
import { take } from 'rxjs';
import {GenUserFeedback} from '../../../generated/serverModels/GenUserFeedback';

@Component({
    selector: 'tgrid-feedback-modal',
    imports: [
        MatLabel,
        MatDialogContent,
        MatFormField,
        MatInput,
        MatSelect,
        ReactiveFormsModule,
        MatOption,
        CdkTextareaAutosize,
        MatButton,
        MatDialogActions,
        MatIconButton,
        MatIcon,
        MatDialogClose,
    ],
    templateUrl: './feedback-modal.component.html',
    styleUrl: './feedback-modal.component.scss',
})
export class FeedbackModalComponent {
  private dialogRef = inject<MatDialogRef<FeedbackModalComponent>>(MatDialogRef);


  private userService = inject(UserService);

  protected feedbackGroup: FormGroup = new FormGroup({
    type: new FormControl<string>('Feedback', {nonNullable: true}),
    description: new FormControl<string>('', {validators: Validators.required}),
  });

  protected submitFeedback() {
    const value = new GenUserFeedback(this.feedbackGroup.getRawValue());

    this.userService.submitFeedback(value).pipe(
      take(1),
    ).subscribe(() => this.dialogRef.close(true));
  }
}
